import React, { useContext } from 'react';
import { HealthAssesment } from '../providers/health-assesment-provider';

export const withFormulas = (Component) => {
  const WithFormulas = (props) => {
    const { healthAssesmentData } = useContext(HealthAssesment);
    const { arCosts, cashFlow, scalability, resilience, general } = healthAssesmentData;

    const getHealthSubCategories = (points) => {
      let health;
      if (points === 1) {
        health = "unhealthy";
      } else if (points === 2) {
        health = "at risk";
      } else if (points === 4 || points === 3) {
        health = "average";
      } else if (points === 5) {
        health = "healthy";
      }
  
      return health;
    }
  
    // ArCosts
    const getCostInvoicePoints = () => {
      const annualRevenue = parseInt(general.a);
      const creditCardPaymentMix = parseInt(arCosts.cc);
      const creditCardRate = parseFloat(arCosts.b);
      const monthlyManHours = parseInt(scalability.b);
      const recurringMontlyCosts = parseInt(arCosts.c);
      const montlyInvoices = parseInt(cashFlow.b);
      const payerPaysFees = resilience.a;
      const creditCardCosts = ((annualRevenue * creditCardPaymentMix) * creditCardRate) / 12;
      const laborCosts = monthlyManHours * 30;
      const addCreditCardCosts = payerPaysFees === "yes" ? 0 : creditCardCosts;
      const totalArCosts = addCreditCardCosts + recurringMontlyCosts + laborCosts;
      const score = totalArCosts / montlyInvoices;
      let invoicePoints;
  
      if (score >= 10) {
        invoicePoints = 1;
      } else if (score >= 3 && score < 10) {
          invoicePoints = 2;
      } else if (score >= 0.71 && score < 3) {
          invoicePoints = 4;
      } else if (score < 0.71) {
        invoicePoints = 5
      }
      return invoicePoints;
    }
  
    const getCostInvoiceHealth = () => {
      const points = getCostInvoicePoints()
      return getHealthSubCategories(points);
    }
  
    const getCreditCardRatePoints = () => {
      const creditCardRate = parseFloat(arCosts.b);
      let creditCardRatePoints;
      if (creditCardRate >= 3.20) {
        creditCardRatePoints = 1;
      } else if (creditCardRate >= 2.3 && creditCardRate < 3.20) {
        creditCardRatePoints = 2;
      } else if (creditCardRate >= 2 && creditCardRate < 2.30) {
        creditCardRatePoints = 4;
      } else if (creditCardRate < 2) {
        creditCardRatePoints = 5
      }
      return creditCardRatePoints;
    }
  
    const getCreditCardRateHealth = () => {
      const points = getCreditCardRatePoints()
      return getHealthSubCategories(points);
    }
  
    const getCostPredictabilityPoints = () => {
      const payerPaysFees = resilience.a;
      const creditCardPaymentMix = parseInt(arCosts.b);
      let costPredictabilityPoints;
      if (payerPaysFees === "no") {
        if(creditCardPaymentMix >= 50) {
          costPredictabilityPoints = 1;
        } else if (creditCardPaymentMix >= 15 && creditCardPaymentMix < 50) {
          costPredictabilityPoints = 2;
        } else if (creditCardPaymentMix < 15) {
          costPredictabilityPoints = 4;
        }
      } else if (payerPaysFees === "yes") {
        costPredictabilityPoints = 5;
      }
  
      return costPredictabilityPoints;
    };
  
    const getCostPredictabilityHealth = () => {
      const points = getCostPredictabilityPoints()
      return getHealthSubCategories(points);
    }
  
    const getArCostsTotalPoints = () => {
      return getCostInvoicePoints() + getCreditCardRatePoints() + getCostPredictabilityPoints();
    }
  
    const getArCostsScore = () => {
      const totalPoints = getArCostsTotalPoints();
      let gradeArCosts;
      if (totalPoints >= 14 && totalPoints <= 15) {
        gradeArCosts = "a";
      } else if (totalPoints >= 12 && totalPoints < 14) {
        gradeArCosts = "b";
      } else if (totalPoints >= 10 && totalPoints < 12) {
        gradeArCosts = "c";
      } else if (totalPoints >= 8 && totalPoints < 10) {
        gradeArCosts = "d";
      } else if (totalPoints < 8) {
        gradeArCosts = "f";
      }
  
      return gradeArCosts;
    }
  
  // Cashflow
    const getDsoPoints = () => {
      const dso = parseInt(cashFlow.a);
      let dsoPoints;
      if (dso >= 48) {
        dsoPoints = 1;
      } else if (dso >= 37 && dso < 48) {
        dsoPoints = 2;
      } else if (dso >= 31 && dso < 37) {
        dsoPoints = 4;
      } else if (dso < 31) {
        dsoPoints = 5;
      }
  
      return dsoPoints;
    }
  
    const getDsoHealth = () => {
      const points = getDsoPoints()
      return getHealthSubCategories(points);
    }

    const getReceivablesBenchmarkPoints = () => {
      const outstanding = parseInt(cashFlow.c);
      let outstandingPoints;
      if (outstanding >= 50) {
        outstandingPoints = 1;
      } else if (outstanding >= 25 && outstanding < 50) {
        outstandingPoints = 2;
      } else if (outstanding >= 10 && outstanding < 25) {
        outstandingPoints = 4;
      } else if (outstanding < 10) {
        outstandingPoints = 5;
      }
  
      return outstandingPoints;
    }

    const getReceivablesBenchmarkHealth = () => {
      const points = getReceivablesBenchmarkPoints()
      return getHealthSubCategories(points);
    }
  
    const getReturningCustomersPoints = () => {
      const returningCustomers = parseInt(cashFlow.e);
      let returningCustomerPoints;
      if (returningCustomers < 50) {
        returningCustomerPoints = 1;
      } else if (returningCustomers >= 50 && returningCustomers <= 74) {
        returningCustomerPoints = 2;
      } else if (returningCustomers >= 75 && returningCustomers <= 89) {
        returningCustomerPoints = 4;
      } else if (returningCustomers >= 90) {
        returningCustomerPoints = 5;
      }
  
      return returningCustomerPoints;
    }
  
    const getReturningCustomersHealth = () => {
      const points = getReturningCustomersPoints()
      return getHealthSubCategories(points);
    }
  
    const getCashFlowTotalPoints = () => {
      return getDsoPoints() + getReceivablesBenchmarkPoints() + getReturningCustomersPoints();
    }
  
    const getCashFlowScore = () => {
      const totalPoints = getCashFlowTotalPoints();
      let gradeCashFlow;
      if (totalPoints >= 14 && totalPoints <= 15) {
        gradeCashFlow = "a";
      } else if (totalPoints >= 12 && totalPoints < 14) {
        gradeCashFlow = "b";
      } else if (totalPoints >= 10 && totalPoints < 12) {
        gradeCashFlow = "c";
      } else if (totalPoints >= 8 && totalPoints < 10) {
        gradeCashFlow = "d";
      } else if (totalPoints < 8) {
        gradeCashFlow = "f";
      }
  
      return gradeCashFlow;
    }
  
    // Scalability
    const getAutomatationSpectrumPoints = () => {
      const manHrs = parseInt(scalability.b);
      const automated = scalability.c === "yes";
      const payNowBtn = scalability.d === "yes";
      let automationPoints = payNowBtn ? 1 : 0;
      automationPoints = automated ? automationPoints + 1 : automationPoints;
  
      if (payNowBtn && automated && manHrs <= 9) {
        automationPoints = 5;
      } else if (manHrs >= 40) {
        automationPoints = automationPoints + 1;
      } else if (manHrs >= 20 && manHrs < 40) {
        automationPoints = automationPoints + 2;
      } else if (manHrs >= 10 && manHrs < 20) {
        automationPoints = automationPoints + 3;
      }
  
      return automationPoints;
    }
  
    const getAutomatationSpectrumHealth = () => {
      const points = getAutomatationSpectrumPoints()
      return getHealthSubCategories(points);
    }
  
    const getMinutesPerInvoicePoints = () => {
      const montlyInvoices = parseInt(cashFlow.b);
      const manHrs = parseInt(scalability.b);
      const totalMinutesSpent = manHrs * 60;
      const minutesPerInvoice = totalMinutesSpent / montlyInvoices;
      let minutesPerInvoicePoints;
      if (minutesPerInvoice >= 5) {
        minutesPerInvoicePoints = 1;
      } else if (minutesPerInvoice === 4) {
          minutesPerInvoicePoints = 2;
      } else if (minutesPerInvoice >= 2 && minutesPerInvoice < 4) {
          minutesPerInvoicePoints = 4;
      } else if (minutesPerInvoice < 2) {
          minutesPerInvoicePoints = 5;
      }

      return minutesPerInvoicePoints;
    }
  
    const getMinutesPerInvoiceHealth = () => {
      const points = getMinutesPerInvoicePoints()
      return getHealthSubCategories(points);
    }
  
    const getArCostRevenuePoints = () => {
      const creditCard = parseInt(arCosts.cc);
      let costRevenuePoints;
  
      if (creditCard >= 50) {
        costRevenuePoints = 1;
      } else if (creditCard >= 30 && creditCard < 50) {
        costRevenuePoints = 2;
      } else if (creditCard >= 15 && creditCard < 30) {
        costRevenuePoints = 4;
      } else if (creditCard < 15) {
        costRevenuePoints = 5;
      }

      return costRevenuePoints;
    }
  
    const getArCostRevenueHealth = () => {
      const points = getArCostRevenuePoints()
      return getHealthSubCategories(points);
    }
  
    const getScalabilityTotalPoints = () => {
      return getAutomatationSpectrumPoints() + getMinutesPerInvoicePoints() + getArCostRevenuePoints();
    }
  
    const getScalabilityScore = () => {
      const totalPoints = getScalabilityTotalPoints();
      let gradeScalability;
      if (totalPoints >= 14 && totalPoints <= 15) {
        gradeScalability = "a";
      } else if (totalPoints >= 12 && totalPoints < 14) {
        gradeScalability = "b";
      } else if (totalPoints >= 10 && totalPoints < 12) {
        gradeScalability = "c";
      } else if (totalPoints >= 8 && totalPoints < 10) {
        gradeScalability = "d";
      } else if (totalPoints < 8) {
        gradeScalability = "f";
      }
  
      return gradeScalability;
    }
  
    // Resilience
    const getDigitalSpectrumPoints = () => {
      const paperChecks = parseInt(arCosts.pc);
      let digitalSpectrumPoints;
  
      if (paperChecks >= 80) {
        digitalSpectrumPoints = 1;
      } else if (paperChecks >= 50 && paperChecks < 80) {
        digitalSpectrumPoints = 2;
      } else if (paperChecks >= 20 && paperChecks < 50) {
        digitalSpectrumPoints = 4;
      } else if (paperChecks < 20) {
        digitalSpectrumPoints = 5;
      }
  
      return digitalSpectrumPoints
    }
  
    const getDigitalSpectrumHealth = () => {
      const points = getDigitalSpectrumPoints()
      return getHealthSubCategories(points);
    }
  
    const getControlSpectrumPoints = () => {
      const dsoPoints = getDsoPoints() * .3;
      const costPredictabilityPoints = getCostPredictabilityPoints() * .7;
      const sumPoints = dsoPoints + costPredictabilityPoints;
      let controlSpectrumPoints;
      if (sumPoints >= 3.9 && sumPoints <= 5) {
        controlSpectrumPoints = 5;
      } else if (sumPoints >= 3.1 && sumPoints < 3.9) {
        controlSpectrumPoints = 4;
      } else if (sumPoints >= 2.1 && sumPoints < 3.1) {
        controlSpectrumPoints = 2;
      } else if (sumPoints >= 1 && sumPoints < 2.1) {
        controlSpectrumPoints = 1;
      }
  
      return controlSpectrumPoints;
    }
  
    const getControlSpectrumHealth = () => {
      const points = getControlSpectrumPoints()
      return getHealthSubCategories(points);
    }
  
    const getResilienceTotalPoints = () => {
      return getDigitalSpectrumPoints() + getControlSpectrumPoints();
    }
  
    const getResilienceScore = () => {
      const totalPoints = getResilienceTotalPoints();
      let gradeResilience;
      if (totalPoints === 9 || totalPoints === 10) {
        gradeResilience = "a";
      } else if (totalPoints === 8) {
        gradeResilience = "b";
      } else if (totalPoints === 6 || totalPoints === 7) {
        gradeResilience = "c";
      } else if (totalPoints === 5) {
        gradeResilience = "d";
      } else if (totalPoints <= 4) {
        gradeResilience = "f";
      }
  
      return gradeResilience;
    }
  
    const getOverallGrade = () => {
      const sumCategories = getArCostsTotalPoints() + getCashFlowTotalPoints() + getScalabilityTotalPoints() + getResilienceTotalPoints();
      let gradeOverall;
      if (sumCategories >= 50 && sumCategories <= 55) {
        gradeOverall = "a";
      } else if (sumCategories >= 44 && sumCategories < 50) {
        gradeOverall = "b";
      } else if (sumCategories >= 38 && sumCategories < 44) {
        gradeOverall = "c";
      } else if (sumCategories >= 32 && sumCategories < 37) {
        gradeOverall = "d";
      } else if (sumCategories <= 31) {
        gradeOverall = "f";
      }
  
      return gradeOverall;
    }

    const formulas = {
      getHealthSubCategories,
      getCostInvoicePoints,
      getCostInvoiceHealth,
      getCreditCardRatePoints,
      getCreditCardRateHealth,
      getCostPredictabilityPoints,
      getCostPredictabilityHealth,
      getArCostsTotalPoints,
      getArCostsScore,
      getDsoPoints,
      getDsoHealth,
      getReceivablesBenchmarkPoints,
      getReceivablesBenchmarkHealth,
      getReturningCustomersPoints,
      getReturningCustomersHealth,
      getCashFlowTotalPoints,
      getCashFlowScore,
      getAutomatationSpectrumPoints,
      getAutomatationSpectrumHealth,
      getMinutesPerInvoicePoints,
      getMinutesPerInvoiceHealth,
      getArCostRevenuePoints,
      getArCostRevenueHealth,
      getScalabilityTotalPoints,
      getScalabilityScore,
      getDigitalSpectrumPoints,
      getDigitalSpectrumHealth,
      getControlSpectrumPoints,
      getControlSpectrumHealth,
      getResilienceTotalPoints,
      getResilienceScore,
      getOverallGrade,
    }

    return <Component {...props} formulas={formulas}  />
  }
  return WithFormulas;
}